export default "__VITE_ASSET__40754f59__"